export class Loader {

    public show = false;

    constructor(
        // show?: boolean
    ) { }
}
